// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddEmployeeModal_modal__3SIlw","title":"AddEmployeeModal_title__3daUV","checkedNumberLabel":"AddEmployeeModal_checkedNumberLabel__3ESnT"};